import { Status } from '../../../../interfaces/Status'
import { REQUESTED, PENDING, IN_PROGRESS, COMPLETED, CANCELLED, DRAFT, ANALYZING } from './tempoStatus'

const statusTransform = (itemStatus: string): Status => {
    switch (itemStatus) {
        case REQUESTED:
            return {
                name: 'tempo.page_project_list.status.requested',
                color: 'requested',
            }
        case PENDING:
            return {
                name: 'tempo.page_project_list.status.pending',
                color: 'pending',
            }
        case IN_PROGRESS:
            return {
                name: 'tempo.page_project_list.status.in_progress',
                color: 'inProgress',
            }
        case COMPLETED:
            return {
                name: 'tempo.page_project_list.status.completed',
                color: 'completed',
            }
        case CANCELLED:
            return {
                name: 'tempo.page_project_list.status.canceled',
                color: 'cancelled',
            }
        case DRAFT:
            return {
                name: 'tempo.page_project_list.status.draft',
                color: 'draft',
            }
        case ANALYZING:
            return {
                name: 'tempo.page_project_list.status.analyzing',
                color: 'analyzing',
            }
        default:
            return {
                name: 'tempo.page_project_list.status.no_status',
                color: 'noStatus',
            }
    }
}

export default statusTransform
